import type { ReactNode } from 'react';
import { cn } from '../../../lib/utils.ts';

type SectionTitleProps = {
    children: ReactNode;
    accessory?: ReactNode;
    className?: string;
};

export function SectionTitle({ children, accessory, className }: SectionTitleProps) {
    return (
        <div className={cn('flex items-center justify-between gap-3', className)}>
            <h3 className="flex items-center text-[14px] font-semibold text-gray-900">{children}</h3>
            {accessory}
        </div>
    );
}
